<template>
  <div class="success-card align-items-center" v-if="success">
    <div class="success success-icon">
      <img src="@/assets/images/common/success-circle.svg" width="20" />
    </div>
    <div class="success-text">
      <p class="mb-0 font-weight-bold">{{ text }}</p>
      <p v-if="description" class="mb-0">{{ description }}</p>
      <span class="error-link">
        <a :href="link">{{ linkText }}</a>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    success: { type: Boolean, required: false, default: false },
    link: { type: String, required: false, default: '' },
    linkText: { type: String, required: false, default: '' },
    text: { type: String, required: true, default: '' },
    description: { type: String, required: false, default: '' }
  }
}
</script>

<style lang="scss">
@import '../../assets/scss/variables';
.success {
  font-family: $nunito;
  font-weight: 700;
  font-size: 0.9rem;
  line-height: 1.2rem;
}
.success-card {
  display: flex;
  border-radius: 0.6rem;
  padding: 16px;
  border: 1px solid $spring-green-600;
  background: $spring-green-100;
}
.success-icon {
  font-size: 2rem;
  margin-right: 8px;
}
.success-text {
  color: $noble-blue-500;
}
</style>
